/* ab-sticky-atc.js — shows after the main ATC scrolls out of view; mirrors buy box state */
(function () {
  function boot() {
    var el = document.querySelector('[data-ab-sticky]'); if (!el || el.__ab) return; el.__ab = true;
    var btn = el.querySelector('[data-ab-sbtn]'), lab = el.querySelector('[data-ab-slabel]'), pr = el.querySelector('[data-ab-sprice]');
    var img = el.querySelector('[data-ab-simg]'), toast = el.querySelector('[data-ab-stoast]');
    var main = document.querySelector('[data-ab-main]'), target = main && main.querySelector('[data-ab-atc]');
    var passed = false;
    function set() { el.classList.toggle('is-visible', passed); }
    function check() { passed = target ? target.getBoundingClientRect().bottom < 0 : window.scrollY > 700; set(); }
    window.addEventListener('scroll', check, { passive: true }); window.addEventListener('resize', check); check();
    function apply(d) { lab.textContent = d.label; pr.textContent = d.price; btn.disabled = !d.available;
      if (img && d.image) img.src = d.image;
    }
    document.addEventListener('ab:buybox', function (e) { apply(e.detail); });
    if (window.ABBuybox && window.ABBuybox.last) apply(window.ABBuybox.last);
    btn.addEventListener('click', function () {
      if (window.ABBuybox) window.ABBuybox.add(); else if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
    document.addEventListener('ab:added', function (e) {
      if (!e.detail.ok || !toast) return; toast.hidden = false; setTimeout(function () { toast.hidden = true; }, 2500);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
